<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="autoscalingDelmodal = true"
            v-hasPermission="['monitor:autoscalingMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:autoscalingMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="autoscalingDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ autoscalingName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAutoscaling()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDateVue = {};
export default {
  name: "TableAutoscaling",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      autoscalingDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      autoscalingName: "",
      columns: [
        {
          title: this.$t("alarms.autoscaling.accountIdString"),
          fixed: "left",
          width: 150,
          key: "accountIdString"
        },
        {
          title: this.$t("alarms.autoscaling.accountName"),
          width: 150,
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          width: 150,
          key: "accountType"
        },
        {
          title: this.$t("alarms.network.nat.region"),
          width: 150,
          key: "region"
        },

        {
          title: this.$t("alarms.autoscaling.scalingGroupId"),
          width: 150,
          key: "scalingGroupId"
        },
        {
          title: this.$t("alarms.autoscaling.scalingGroupName"),
          width: 150,
          key: "scalingGroupName"
        },
        {
          title: this.$t("alarms.autoscaling.groupType"),
          width: 150,
          key: "groupType"
        },
        {
          title: this.$t("alarms.autoscaling.vpcId"),
          width: 150,
          key: "vpcId"
        },
        {
          title: this.$t("alarms.autoscaling.totalInstanceCount"),
          width: 150,
          key: "totalInstanceCount"
        },
        {
          title: this.$t("alarms.autoscaling.lifecycleState"),
          width: 150,
          key: "lifecycleState"
        },
        {
          title: this.$t("alarms.autoscaling.minSize"),
          width: 150,
          key: "minSize"
        },
        {
          title: this.$t("alarms.autoscaling.maxSize"),
          width: 150,
          key: "maxSize"
        },
        {
          title: this.$t("alarms.autoscaling.scalingPolicy"),
          width: 150,
          key: "scalingPolicy"
        },
        {
          title: this.$t("alarms.autoscaling.healthCheckType"),
          width: 150,
          key: "healthCheckType"
        },
        {
          title: this.$t("alarms.instance.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("common.operation"),
          fixed: "right",
          width: 150,
          slot: "delete"
        }
      ],
      tableDate: []
    };
  },
  beforeCreate: function() {
    tableDateVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableDateVue.companyId = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDateVue.accountName = val;
    });
    eventBus.$on("scalingGroupName", function(val) {
      tableDateVue.scalingGroupName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDateVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      //列表分页
      this.$api.autoscaling
        .pageAutoscaling({
          pageNum: this.current,
          pageSize: this.pageSize,
          accountName: tableDateVue.accountName,
          companyId: tableDateVue.companyId,
          scalingGroupName: tableDateVue.scalingGroupName
        })
        .then(res => {
          this.tableDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDateVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDateVue.getData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.autoscalingName = this.tableDate[index].accountName;
    },
    removeAutoscaling: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.autoscaling
        .deleteAuto("id", this.tableDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableDateVue.getData();
            this.isDisable = false;
            this.modal_loading = false;
            this.autoscalingDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/autoscalingDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          companyId: row.companyId,
          name: row.scalingGroupName,
          region: row.region,
          monitorModule: 40,
          accountName: row.accountName,
          accountType: row.accountType,
          scalingGroupId: row.scalingGroupId
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/autoscaling/TableAutoscaling.vue